<div class="empty-state">
  <svg class="empty-state__marca" viewBox="0 0 545 409" role="img" aria-label="Inteliax">
    <path d="M0 0L72.59 93.29H211.998L143.235 0H0Z" />
    <path d="M211.988 93.2888L272.486 175.331L332.984 93.2888H211.988Z" />
    <path d="M401.765 0L333.002 93.29H472.41L545 0H401.765Z" />
    <path d="M545 408.75L472.41 315.46H333.002L401.765 408.75H545Z" />
    <path d="M332.984 315.459L272.486 233.417L211.988 315.459H332.984Z" />
    <path d="M143.235 408.75L211.998 315.46H72.59L0 408.75H143.235Z" />
  </svg>

  <h2 class="empty-state__title">{{ title }}</h2>
  <p class="empty-state__message">{{ message }}</p>

  <span class="empty-state__assinatura">Inteliax</span>
</div>
